<app-image-upload-overlay [projectId]="project.id" [useProjectPhotosMobileModals]="isMobile()" (image$)="onImageUploaded($event)">
  <div class="container flex-scroll p-0-24-24">
    <!-- prettier-ignore -->
    @if (images.length === 0) {
      <h6 class="odx-subtitle-6" i18n="@@imageUpload.noImageYet">Sie haben noch keine Fotos hinzugefügt.</h6>
    }
    @if (isMobile()) {
      <div class="mobile-image-list">
        @for (image of images; track image) {
          <app-project-detail-mobile-image-card
            (delete$)="onDelete(image.imageMetadata)"
            (submit$)="onCardSubmit($event, image.imageMetadata)"
            (preview$)="openModal(image.imageMetadata)"
            (toggleExpand$)="toggleImageExpansion(image.imageMetadata)"
            [expanded]="expandedImageId === image.imageMetadata.id"
            [fileUrl]="image.previewUrl ?? ''"
            [fileName]="image.imageMetadata.name"
            [description]="image.imageMetadata.description"
            [hasWritePermission]="hasWritePermission()"
            [isMonitoringScope]="isMonitoringScope()"
            [isReadOnlyUser]="isReadOnlyUser()"
            [tagList]="imageTagList()"
            [tags]="image.imageMetadata.tags"
          >
          </app-project-detail-mobile-image-card>
        }
      </div>
    } @else {
      <div odxLayout="grid 3@desktop 4@tablet 6@phone">
        @for (image of images; track image) {
          <app-image-card
            (delete$)="onDelete(image.imageMetadata)"
            (submit$)="onCardSubmit($event, image.imageMetadata)"
            (click$)="openModal(image.imageMetadata)"
            [fileUrl]="image.previewUrl ?? ''"
            [fileName]="image.imageMetadata.name"
            [description]="image.imageMetadata.description"
            [tags]="image.imageMetadata.tags"
          >
          </app-image-card>
        }
      </div>
    }
  </div>
</app-image-upload-overlay>
